import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import ApexChart from "../components/Chart"
import { getAllUserData, getDailyUsers, getFreeUsers, getSubscriptionUsers, getTotalIncome } from "../firebase/users"
import { useAuth } from "../context/authContext"
import { hasAllPrivileges } from "../utils"
import { subAdminPrivilege } from "../utils/data"

const Dashboard = () => {
    const [activeTab, setActiveTab] = useState('all')
    const [freeUsers, setFreeUsers] = useState(0)
    const [dailyUsers, setDailyUsers] = useState(0)
    const [subscriptionUsers, setSubscriptionUsers] = useState(0)
    const [totalIncome, setTotalIncome] = useState(0)

    const {userData} = useAuth()
    const user = userData
    // const [data, setData] = useState({ free_users: 0, daily_users: 0, subscription_users: 0, monthly_revenue: 0 })

    useEffect(() => {
        getAllUserData().then(users => {
            setFreeUsers(users.filter(item => item.membership === 'free').length)
            setSubscriptionUsers(users.filter(item => item.membership !== 'free').length)
        })

        getDailyUsers().then(users => {
            setDailyUsers(users)
        })
    }, [])

    useEffect(() => {
        getTotalIncome(activeTab).then(total => {
            setTotalIncome(total)
        })
    }, [activeTab])

    return (
        <div className="px-10 py-8">
            <h1 className="text-primary text-[36px]">Dashboard</h1>

            <div className="pl-1 mt-6">
                <div className="flex items-center">
                    <div className="mr-3 text-lg text-white">Quick Stats:</div>

                    <button
                        className={`px-3 py-2 mr-2 rounded-[10px] text-sm ${activeTab === 'all' ? 'bg-[#F0F1FF]' : 'bg-[#2F2F2F] text-[#B9B9B9]'}`}
                        onClick={() => setActiveTab('all')}
                    >
                        All Time
                    </button>

                    <button
                        className={`px-3 py-2 mr-2 rounded-[10px] text-sm ${activeTab === 'month' ? 'bg-[#F0F1FF]' : 'bg-[#2F2F2F] text-[#B9B9B9]'}`}
                        onClick={() => setActiveTab('month')}
                    >
                        Last Month
                    </button>

                    <button
                        className={`px-3 py-2 rounded-[10px] text-sm ${activeTab === 'week' ? 'bg-[#F0F1FF]' : 'bg-[#2F2F2F] text-[#B9B9B9]'}`}
                        onClick={() => setActiveTab('week')}
                    >
                        Last Week
                    </button>
                </div>

                <div className="mt-4 flex items-center">
                    <div className="bg-[#2F2F2F] w-[221px] h-[115px] rounded-[15px] p-4 mr-2">
                        <h2 className="text-[36px] leading-[1.1em] text-primary">{freeUsers}</h2>
                        <div className="text-sm text-white mt-4">Total Free Users</div>
                    </div>
                    <div className="bg-[#2F2F2F] w-[221px] h-[115px] rounded-[15px] p-4 mr-2">
                        <h2 className="text-[36px] leading-[1.1em] text-primary">{dailyUsers}</h2>
                        <div className="text-sm text-white mt-4">Average Daily Users</div>
                    </div>
                    <div className="bg-[#2F2F2F] w-[221px] h-[115px] rounded-[15px] p-4 mr-2">
                        <h2 className="text-[36px] leading-[1.1em] text-primary">{subscriptionUsers}</h2>
                        <div className="text-sm text-white mt-4">Active Subscriptions</div>
                    </div>
                    <div className="bg-[#2F2F2F] w-[221px] h-[115px] rounded-[15px] p-4">
                        <h2 className="text-[36px] leading-[1.1em] text-primary">$ {totalIncome.toFixed(2)}</h2>
                        <div className="text-sm text-white mt-4">Revenue</div>
                    </div>
                </div>

                <div className="mt-5 grid grid-cols-2 gap-x-5">
                    <div className="h-[460px] bg-[#2f2f2f] rounded-[15px] p-[30px]">
                        <div className="text-white">
                            Quick Actions
                        </div>

                        {
                            user.role === 'admin' &&
                            <Link to='/user' className="block mt-6 p-4 w-full h-[83px] rounded-[15px] bg-[#5C5C5C]">
                                <img src="/assets/icons/icon-user.svg" alt="user" />

                                <div className="mt-3 flex justify-between items-center w-full text-white">
                                    <div>User Manager</div>

                                    <img src="/assets/icons/icon-arrow-long-right.svg" alt="arrow" />
                                </div>
                            </Link>
                        }
                        {
                            (user.role === 'admin' || (user.role === 'sub-admin' && hasAllPrivileges(user.privileges, [subAdminPrivilege.CATEGORY_MANAGER]))) &&
                            <Link to='/category' className="block mt-6 p-4 w-full h-[83px] rounded-[15px] bg-[#5C5C5C]">
                                <img src="/assets/icons/icon-list.svg" alt="user" />

                                <div className="mt-3 flex justify-between items-center w-full text-white">
                                    <div>Category Manager</div>

                                    <img src="/assets/icons/icon-arrow-long-right.svg" alt="arrow" />
                                </div>
                            </Link>
                        }
                        <div to='/category' className="block mt-6 p-4 w-full h-[83px] rounded-[15px] bg-[#5C5C5C]">
                            <img src="/assets/icons/icon-alarm.svg" alt="user" />

                            <div className="mt-3 flex justify-between items-center w-full text-white">
                                <div>Coming Soon</div>

                                <img src="/assets/icons/icon-arrow-long-right.svg" alt="arrow" />
                            </div>
                        </div>
                    </div>

                    <div className="h-[460px] bg-[#2f2f2f] rounded-[15px] p-[30px]">
                        <ApexChart />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard